import * as React from 'react';
import * as moment from 'moment';
import axios from 'axios';
import { createCombinedStore, ICalendarSettings, ICalendarState, CalendarActions } from '@adage/ace-calendar';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import App from './containers/app';
import { IWACEvent } from './classes/event';

import calendarModeModel from './redux/reducers/calendar-mode';
import filterModel from './redux/reducers/filter-reducer';
import lazyLoaderModel from './redux/reducers/lazy-loader-reducer';
import calendarTextModel from './redux/reducers/calendar-text-reducer';

import { requestCalendarText, receiveCalendarText } from "./redux/actions/calendar-text-actions";

declare var numberOfMonths: number;
numberOfMonths = numberOfMonths ? numberOfMonths : 2;

let defaultState: ICalendarState<IWACEvent> = {
    updating: false,
    specificDates: false,
    extendEvents: false,
    startDate: moment().clone().startOf("day"),
    endDate: moment().clone().add((numberOfMonths < 2 ? numberOfMonths : 2), "month").endOf('month'),
    currentDate: moment(),
    eventFilter: [],
    productionSeasonFilter: 0,
    filterFunction: () => { return true; },
    events: []
};

let calendarSettings: ICalendarSettings = {
    loadWrappingMonthDates: false,
    saveHistory: false
};

createCombinedStore({ calendarModeModel, filterModel, lazyLoaderModel, calendarTextModel }, { 'calendarModel': defaultState });

CalendarActions.calendarDispatch()(requestCalendarText());
// Dispatch request to get epi text for application.
axios.get("/api/Calendar/GetCalendarText").then(response => {
    CalendarActions.calendarDispatch()(receiveCalendarText(response.data));
});

render(
    <Provider store={CalendarActions.calendarStore()}>
        <App monthsToDisplay={numberOfMonths} />
    </Provider>
    , document.getElementById("app-container"));


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/index.tsx